export const Card = ({
  icon,
  title,
  text,
  minHeight,
  alignItems,
  textAlign,
}) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: alignItems,
          background: "#FFFFFF",
          boxShadow: "0px 4px 20px -2px #32324714, 0px 0px 1px 0px #0C1A4B1A",
          width: "100%",
          margin: " auto",
          maxWidth: "416px",
          padding: "30px",
          paddingRight: "50px",
          borderRadius: "10px",
          height: "100%",
          minHeight: minHeight,
          textAlign: textAlign,
        }}
      >
        <img width="90px" height="90px" src={icon} alt=""></img>
        <div>
          <h3 className="mt-3">{title}</h3>
          <p dangerouslySetInnerHTML={{ __html: text }}></p>
        </div>
      </div>
    </>
  );
};
